<template>
  <div class="tj-page">
    <template v-if="isShowLimit">
      <div class="limit-bg"></div>
      <div class="limit-container">
        <template v-if="!loginUid">
          <div class="title">登录后浏览更多内容</div>
          <div class="infos">GameKee健康系统提示您，根据相关规定，您需要登录后才能继续浏览</div>
        </template>
        <div v-if="loginUser && !loginUser.adulthood && loginUser.verify_level === 2" class="tips">
          <img src="@/assets/icons/icon-tips-error.png" alt="" />
          <span>
            Gamekee温馨提示您：
            <br />
            由于您暂未满18岁，该页面内容无法浏览，您可前往首页浏览其它内容～
          </span>
        </div>
        <template v-else>
          <div class="tips">
            温馨提示：
            <br />
            如果您登录的账号是未成年人（未满18岁）的身份信息将会
            <br />
            受到以下影响
          </div>
          <div class="text">【部分内容无法完全浏览】</div>
        </template>

        <div class="button-option">
          <div class="btn borderd" @click="goBackHome">回到首页</div>
          <div
            class="btn"
            v-if="!loginUid || (loginUser && !loginUser.adulthood && loginUser.verify_level !== 2)"
            @click="handleVerify"
          >
            实名认证
          </div>
        </div>
      </div>
    </template>
    <!-- <div id="__nikke-tj-particles-background-dom__"></div> -->
    <template v-else>
      <div class="bg"></div>
      <ViewComp :detail="detail">
        <div style="padding: 10px;background: #fff;border-radius: 8px;">
          <!-- 正文底部 -->
          <DetailFooter :detail="detail" @refresh="refresh"></DetailFooter>
          <!-- 帖子表情包 -->
          <DetailEmojiBar :detail="detail" @emojiCheck="onEmojiCheck" />
          <div class="comment-box">
            <div class="title">评论（{{ detail.comment_count }}）</div>
            <!-- 评论 -->
            <DetailComment
              :detail="detail"
              :list="list"
              :pagination="pagination"
              @refresh="refresh"
              @getCommentList="getCommentList"
            />
          </div>
        </div>
      </ViewComp>
      <!-- 返回 -->
      <DetailBack :position="position" />
      <!-- 返回首页 -->
      <DetailBackHome :position="position" @goBackHome="goBackHome" />
      <!-- 侧边 -->
      <DetailAside
        v-show="!dialogVisible"
        :detail="detail"
        :commentList="list"
        :commentPagination="pagination"
        :position="position"
        @refresh="refresh"
        @getCommentList="getCommentList"
        @showAside="handleShowAside"
        @comment="onClickComment"
        @share="onClickShare"
        :showOptions="{
          avatar: false,
          like: true,
          favorite: true,
          comment: true,
          shareImage: true,
          shareText: false,
          goEdit: false,
          goTJEdit: true
        }"
      ></DetailAside>
    </template>

    <el-dialog
      :title="`评论（${detail.comment_count}）`"
      :visible.sync="dialogVisible"
      width="684px"
      :close-on-click-modal="true"
      custom-class="comment-dialog"
      top="10vh"
    >
      <DetailComment
        ref="commentRef"
        :detail="detail"
        :list="list"
        :pagination="pagination"
        @refresh="refresh"
        @getCommentList="getCommentList"
      />
      <div class="fllow-body">
        <div class="item" @click="onLike">
          <img
            class="icon"
            :src="
              `${
                detail.is_like
                  ? require('@/assets/images/aside_dianzanle.png')
                  : require('@/assets/images/aside_dianzan.png')
              }`
            "
          />
          <span class="txt">{{ formatCount(detail.like_count) }}</span>
        </div>
        <div class="item" @click="onFavorite">
          <img
            class="icon"
            :src="
              `${
                detail.is_favorite
                  ? require('@/assets/images/aside_shoucangle.png')
                  : require('@/assets/images/aside_shoucang.png')
              }`
            "
          />
          <span class="txt">{{ formatCount(detail.favorite_count) }}</span>
        </div>
        <div class="item" @click="onShare">
          <img class="icon" :src="`${require('@/assets/images/aside_fenxiang.png')}`" />
          <span class="txt">分享</span>
        </div>
      </div>
    </el-dialog>
    <AdultCheck ref="adultCheckRef" />
  </div>
</template>

<script>
import Clipboard from "clipboard";
import { mapGetters } from "vuex";
import ViewComp from "./view/index.vue";
import DetailAside from "@/views/wiki/detail/components/detailAside.vue";
import DetailComment from "@/views/wiki/detail/components/detailComment.vue";
import DetailEmojiBar from "@/views/wiki/detail/components/detailEmojiBar.vue";
import DetailFooter from "@/views/wiki/detail/components/detailFooter.vue";
import DetailBack from "@/views/wiki/detail/components/detailBack.vue";
import DetailBackHome from "@/views/wiki/detail/components/detailBackHome.vue";
// plugins
import eventBus from "@/plugins/eventBus";
// import { loadScript } from "@/plugins/util";
// api
import { apiContentDetail, apiContentLike } from "@/api/contentApi";
import { apiCommentList } from "@/api/commentApi";
import { apiUserAddFavorite } from "@/api/userApi";
import AdultCheck from "@/layout/wiki/components/adultCheck.vue";

// const particlesConfig = {
//   particles: {
//     number: {
//       value: 80,
//       density: {
//         enable: true,
//         value_area: 800
//       }
//     },
//     color: {
//       value: "#afc8d0"
//     },
//     shape: {
//       type: "circle",
//       stroke: {
//         width: 0,
//         color: "#000000"
//       },
//       polygon: {
//         nb_sides: 5
//       },
//       image: {
//         src: "img/github.svg",
//         width: 100,
//         height: 100
//       }
//     },
//     opacity: {
//       value: 0.5,
//       random: false,
//       anim: {
//         enable: false,
//         speed: 1,
//         opacity_min: 0.1,
//         sync: false
//       }
//     },
//     size: {
//       value: 3,
//       random: true,
//       anim: {
//         enable: false,
//         speed: 40,
//         size_min: 0.1,
//         sync: false
//       }
//     },
//     line_linked: {
//       enable: true,
//       distance: 150,
//       color: "#afc8d0",
//       opacity: 0.4,
//       width: 1
//     },
//     move: {
//       enable: true,
//       speed: 6,
//       direction: "none",
//       random: false,
//       straight: false,
//       out_mode: "out",
//       bounce: false,
//       attract: {
//         enable: false,
//         rotateX: 600,
//         rotateY: 1200
//       }
//     }
//   },
//   interactivity: {
//     detect_on: "canvas",
//     events: {
//       onhover: {
//         enable: true,
//         mode: "repulse"
//       },
//       onclick: {
//         enable: true,
//         mode: "push"
//       },
//       resize: true
//     },
//     modes: {
//       grab: {
//         distance: 400,
//         line_linked: {
//           opacity: 1
//         }
//       },
//       bubble: {
//         distance: 400,
//         size: 40,
//         duration: 2,
//         opacity: 8,
//         speed: 3
//       },
//       repulse: {
//         distance: 200,
//         duration: 0.4
//       },
//       push: {
//         particles_nb: 4
//       },
//       remove: {
//         particles_nb: 2
//       }
//     }
//   },
//   retina_detect: true
// };

export default {
  components: {
    ViewComp,
    DetailAside,
    DetailComment,
    DetailEmojiBar,
    DetailFooter,
    DetailBack,
    DetailBackHome,
    AdultCheck
  },
  data() {
    return {
      isDeactivated: false,
      detail: {
        user: { uid: 0 }
      },
      hasHistory: false,
      asideBarStyle: {},
      dialogVisible: false,
      // 评论列表
      list: [],
      pagination: {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      },
      loadCommentStatus: "",
      position: null,
      isShowLimit: false
    };
  },
  computed: {
    ...mapGetters(["loginUser", "loginUid"])
  },
  activated() {
    if (this.isDeactivated) {
      document.body.style.overflowY = "hidden";
      this.getDetail();
      // 获取评论
      this.getCommentList("refresh");
    }
  },
  deactivated() {
    document.body.style.overflowY = null;
    this.isDeactivated = true;
  },
  mounted() {
    document.body.style.overflowY = "hidden";
    this.watchPosition();
    // 获取内容
    this.getDetail();
    // 获取评论
    this.getCommentList();
    window.addEventListener("resize", () => {
      this.watchPosition();
    });

    // 背景粒子效果
    // setTimeout(() => {
    //   loadScript(`${process.env.VUE_APP_CDN_BASE}dist/static/particles.js?t=10809`).then(() => {
    //     const particlesJS = window.particlesJS;
    //     particlesJS("__nikke-tj-particles-background-dom__", particlesConfig);
    //   });
    // }, 300);
  },
  beforeDestroy() {
    document.body.style.overflowY = null;
  },
  methods: {
    goBackHome() {
      this.$store.commit("set_ssr_component_data", []);
      this.$router.replace(`/${this.alias}`).then(() => {
        // this.$router.go(0)
        window.location.reload();
      });
    },
    watchPosition() {
      const detailEl = document.querySelector(".tj-page");
      if (!detailEl) return;
      const detailPostion = detailEl.getBoundingClientRect();
      this.position = {
        left: detailPostion.left,
        top: detailPostion.top,
        right: detailPostion.right,
        bottom: detailPostion.bottom
      };
    },
    handleShowAside(isShow) {
      this.showAside = isShow;
      this.$nextTick(() => {
        this.watchPosition();
      });
    },
    goBack() {
      window.history.back();
      // 将服务端数据置空，防止动态切换默认渲染此数据
      this.$store.commit("set_ssr_component_data", []);
    },
    // 刷新详情
    refresh(detail, user) {
      // 将服务端数据置空，防止动态切换默认渲染此数据
      this.$store.commit("set_ssr_component_data", []);
      if (detail) {
        this.$set(this, "detail", detail);
      }
      if (user) {
        this.$set(this, "user", user);
      }
    },
    // 获取文章详情
    async getDetail() {
      let { id = "" } = this.$route.params;
      id = id.split("_")[0];

      try {
        const res = await apiContentDetail({ id });
        if (res.code == 0) {
          this.detail = res.data;
          if (this.detail.editor_type != 3) {
            this.$router.replace({
              path: `/${this.alias}/rich-table?id=${this.detail.id}&entry_id=${this.detail.entry_id}&title=${this.detail.title}`
            });
            return;
          }
        }
      } catch (err) {
        if (err && err.code === 50001) {
          this.isShowLimit = true;
          if (!this.loginUid) {
            eventBus.$emit("onShowLogin");
          } else if (this.loginUser && !this.loginUser.adulthood && this.loginUser.verify_level !== 2) {
            this.$refs.adultCheckRef.visible = true;
          }
          return;
        }
        // 文章审核中
        if (err && err.code === 100002) {
          this.detail = {
            isUnderReview: 1
          };
          return;
        }
        // 文章禁用
        if (err && err.code === 100010) {
          this.detail = {
            audit_state: -1
          };
          return;
        }
        if (err && err.code == 1002 && err.msg == "文章不存在: record not found") {
          // 没有文章信息，重定向到404
          this.$router.replace("/404");
        }
      }
    },
    // 获取评论
    async getCommentList(type) {
      let { id = "" } = this.$route.params;
      if (id.includes("_")) return;
      if (type == "refresh") {
        this.pagination = {
          limit: 10,
          page_no: 0,
          page_total: 1,
          total: 0
        };
        this.list = [];
      }
      let { pagination } = this;
      if (pagination.page_no >= pagination.page_total) {
        this.loadCommentStatus = "end";
        return;
      }

      ++pagination.page_no;
      let params = {
        ...pagination,
        content_id: Number(id)
      };
      this.loadCommentStatus = "loading";
      await apiCommentList(params)
        .then(res => {
          if (res.code == 0) {
            this.list = this.list.concat(res.data);

            this.pagination = res.meta.pagination;
            // if (this.list.length > 2 && this.pagination.page_no == 1) {
            // }
          }
        })
        .finally(_ => {
          this.loadCommentStatus = "";
        });
    },
    onClickComment() {
      this.dialogVisible = true;
    },
    onClickShare() {
      eventBus.$emit("openNikkeTJShare");
    },
    formatCount(count) {
      if (count > 100000000) {
        const num = count / 100000000;
        if (num == (count / 100000000).toFixed(1)) {
          return num + "亿";
        } else {
          return (count / 100000000).toFixed(1) + "亿+";
        }
      } else if (count >= 10000) {
        const num = count / 10000;
        if (num == (count / 10000).toFixed(1)) {
          return num + "W";
        } else {
          return (count / 10000).toFixed(1) + "W+";
        }
      } else if (count >= 1000) {
        const num = count / 1000;
        if (num == (count / 1000).toFixed(1)) {
          return num + "K";
        } else {
          return (count / 1000).toFixed(1) + "K+";
        }
      } else {
        return count;
      }
    },
    onLike() {
      // if (!this.isLogin()) {
      //   return false;
      // }
      let params = {
        is_like: this.detail.is_like ? 0 : 1,
        origin_id: this.detail.id,
        type: 1
      };
      apiContentLike(params).then(res => {
        this.detail.is_like = params.is_like;
        params.is_like ? this.detail.like_count++ : this.detail.like_count--;
        if (this.detail.like_count < 0) this.detail.like_count = 0;
        this.$emit("refresh", this.detail);
      });
    },
    onFavorite() {
      if (!this.isLoginShow()) return false;
      let params = {
        origin_id: this.detail.id,
        type: 1
      };
      apiUserAddFavorite(params).then(res => {
        if (res.code == 0) {
          this.detail.is_favorite = this.detail.is_favorite ? 0 : 1;
          this.detail.is_favorite ? this.detail.favorite_count++ : this.detail.favorite_count--;
          this.$emit("refresh", this.detail);
        }
      });
    },
    onShare() {
      let shareText = `${this.detail.user.username}分享了文章:${this.detail.title}\r\n`;
      shareText += window.location.href + "\r\n";
      shareText += "来自GameKee";

      let $div = document.createElement("div");
      $div.setAttribute("data-clipboard-text", shareText);
      $div.classList.add("page-share-copy-btn");
      document.body.appendChild($div);
      let clipboard = new Clipboard(".page-share-copy-btn");
      clipboard.on("success", e => {
        this.$message("复制成功！");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        this.$message("浏览器不支持自动复制,请更换其他浏览器");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      $div.click();
    },
    /** 点击帖子底部某个表情也视为点赞 */
    onEmojiCheck() {
      if (this.detail.is_like === 0) {
        this.detail.like_count++;
      }
      this.detail.is_like = 1;
    },
    handleVerify() {
      if (!this.loginUid) {
        eventBus.$emit("onShowLogin");
      } else {
        this.$refs.adultCheckRef.visible = true;
      }
    }
  }
};
</script>
<style>
#__nikke-tj-particles-background-dom__ {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}
</style>
<style lang="less" scoped>
/deep/ .comment-dialog {
  border-radius: 16px;
  .el-dialog__header {
    padding: 20px 32px 0;
    .el-dialog__headerbtn {
      right: 32px;
      top: 22px;
    }
  }
  .el-dialog__body {
    padding: 22px 32px;
  }
}
.tj-page {
  width: 1223px;
  height: calc(100vh - 76px);
  margin: 0 auto;
  .bg {
    position: relative;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: url("~@/assets/nikke_imgs/page-bg-1.png") no-repeat;
    background-size: cover;
    pointer-events: none;
    // &::after {
    //   content: "";
    //   position: absolute;
    //   bottom: -9px;
    //   display: block;
    //   width: 100vw;
    //   height: 100vh;
    //   background: url("~@/assets/nikke_imgs/page-bg-2.png") no-repeat;
    //   background-size: 100% auto;
    //   background-position: bottom;
    //   pointer-events: none;
    // }
  }
  .limit-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: url("~@/assets/images/limit_age_bg.png") no-repeat;
    background-size: cover;
    pointer-events: none;
  }
  .limit-container {
    z-index: 2;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 210px;
    .title {
      font-weight: 500;
      font-size: 28px;
      color: #333333;
    }
    .infos {
      margin-top: 30px;
      margin-bottom: 42px;
      // font-weight: bold;
      font-size: 24px;
      color: rgba(51, 51, 51, 0.9);
    }
    .tips {
      // font-weight: 500;
      font-size: 20px;
      color: rgba(51, 51, 51, 0.85);
      line-height: 22px;
      text-align: center;
      img {
        width: 18px;
        height: 18px;
      }
    }
    .text {
      margin-top: 24px;
      font-size: 16px;
      color: rgba(51, 51, 51, 0.65);
      text-align: center;
    }
    .button-option {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 32px;
      gap: 0 15px;
      .btn {
        width: 260px;
        height: 42px;
        border-radius: 22px;
        line-height: 42px;
        text-align: center;
        color: #fff;
        font-size: 16px;
        box-sizing: border-box;
        background-color: #198ff8;
        cursor: pointer;
      }
      .borderd {
        background: #fff;
        border: 2px solid #198ff8;
        color: #198ff8;
      }
    }
  }
}

.fllow-body {
  position: absolute;
  bottom: 20px;
  right: -74px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  .item {
    width: 58px;
    height: 58px;
    border-radius: 30px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 14px;
    cursor: pointer;
    .icon {
      font-size: 0;
      width: 28px;
      height: 28px;
    }
    .txt {
      color: #424242;
      font-size: 11px;
    }
  }
}

.comment-box {
  margin-top: 30px;
  .title {
    font-weight: 500;
    font-size: 16px;
    color: #424242;
    line-height: 52px;
    margin-bottom: 10px;
  }
}
</style>
